import { useEffect, useState } from 'react';

const initialQuery = {
  selectedFilter: 'filename',
  dateRange: { created_on: { type: 'date', start: null, end: null } },
  page: 1,
  limit: 10,
};

const useBulkUploadFilters = (props) => {
  const { defaultQuery, dispatch, fetchAction, markCreatedAction } = props;

  const [searchTerm, setSearchTerm] = useState('');

  const [currentQuery, setCurrentQuery] = useState({ ...initialQuery, ...defaultQuery });

  useEffect(() => {
    if (markCreatedAction) {
      dispatch(markCreatedAction(false));
    }
    applyFilters();
  }, [dispatch, markCreatedAction]);

  useEffect(() => {
    applyFilters();
  }, [currentQuery]);

  const applyFilters = () => {
    const query = {
      page: currentQuery.page,
      limit: currentQuery.limit,
    };

    if (searchTerm) {
      query[currentQuery.selectedFilter] = searchTerm;
    }
    console.log(currentQuery);
    if (currentQuery.dateRange?.document_date?.start || currentQuery.dateRange?.document_date?.end) {
      const { start, end } = currentQuery.dateRange.document_date;
      const cleanDateObject = { ...(start && { start }), ...(end && { end }) };
      if (Object.keys(cleanDateObject).length) {
        query.created_on = JSON.stringify(cleanDateObject);
      }
    }

    if (Object.keys(query).length > 0) {
      dispatch(fetchAction({ query: query }));
    }
  };

  const handleFilterChange = (event) => setCurrentQuery({ ...currentQuery, selectedFilter: event.target.value });

  const handleSearchChange = (event) => setSearchTerm(event.target.value);

  const handleDateRangeChange = (newDateRange) => setCurrentQuery({ ...currentQuery, dateRange: newDateRange });

  const handlePaginationChange = (page, limit) => setCurrentQuery({ ...currentQuery, page: page, limit: limit });

  const handleSearchKeyPress = (event) => {
    if (event.key === 'Enter') {
      applyFilters();
    }
  };

  return {
    searchTerm,
    currentQuery,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handleDateRangeChange,
    handlePaginationChange,
  };
};

export default useBulkUploadFilters;
